<div class="cabecera">
    <span class="titulo">¡ATENCION!</span>
    <button class="btn-cerrar" (click)="onCancel()"></button>
  </div>
  
  <div class="contenido">
    <div class="text-container">
      <div class="text">
        <h1>¿Esta seguro que desea salir sin guardar?</h1>
        <p>Tienes cambios que todavía no han sido guardados</p>
      </div>
    </div>
  
    <div class="btn-container">
      <button class="btn-si" (click)="confirmarSalir()">Si</button>
      <button class="btn-no" (click)="cancelarSalir()">No</button>
    </div>
  </div>
  